var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagnosisIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1689",
    "data-name": "Rectangle 1689",
    width: 99,
    height: 99,
    transform: "translate(0.133 -0.127)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Diagnosis_icon",
    transform: "translate(-0.133 0.127)",
    opacity: 0.5,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Diagnosis_icon-2",
    "data-name": "Diagnosis icon",
    transform: "translate(19.536 9.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13437",
    "data-name": "Path 13437",
    d: "M73.533,32.539a3.07,3.07,0,0,1,2.046,3.334c-.051,5.253.051,10.507-.025,15.76-.126,8.208-3.94,14.194-11.315,17.806a29.175,29.175,0,0,1-4.5,1.44c-.3.1-.606.126-.934.2V94.242a11.913,11.913,0,0,0,3.384,8.739,11.6,11.6,0,0,0,12.477,3.182A11.533,11.533,0,0,0,83,96.389a33.134,33.134,0,0,0,.177-4.5V83.1a29.04,29.04,0,0,1-3.738-2.147,10.347,10.347,0,0,1,3.965-18.286A10.409,10.409,0,0,1,94.016,79.239,9.8,9.8,0,0,1,89.268,82.6a.988.988,0,0,0-.833,1.137c0,4.142.152,8.284-.126,12.4-.631,9.951-10.229,17.351-20.1,15.659A17.4,17.4,0,0,1,53.656,96.439a20.1,20.1,0,0,1-.076-2.475V71.107c-.783-.177-1.515-.3-2.223-.505A19.269,19.269,0,0,1,36.835,51.634c0-5.253.025-10.507-.025-15.76a3.125,3.125,0,0,1,2.046-3.334H48.5c.152.1.3.177.455.278a2.616,2.616,0,0,1-.732,4.95,7.819,7.819,0,0,1-1.086.051h-5c0,.253-.025.429-.025.606,0,4.47-.076,8.941.025,13.411a15.143,15.143,0,0,0,.758,4.622,14.073,14.073,0,0,0,27.378-3.915c.1-4.748.025-9.522.051-14.27a1.646,1.646,0,0,0-.051-.455h-.859c-1.591,0-3.157.025-4.748,0a2.613,2.613,0,0,1-2.6-3.309,3.191,3.191,0,0,1,1.844-1.945h9.648ZM90.985,72.774a5.165,5.165,0,1,0,.025,0Z",
    transform: "translate(-36.809 -32.539)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagnosisIcon);
export default __webpack_public_path__ + "static/media/Diagnosis_icon.be0dc993752422e133c2c374ebd4e330.svg";
export { ForwardRef as ReactComponent };